import { expressionsJson, type ExpressionsJsonItem } from "@corca/data";

import { filterSuggestions } from "./utils/filterSuggestions";
import { injectNodePropsToSuggestion } from "./utils/injectNodePropsToSuggestion";
import { normalizeSuggestionKeywords } from "./utils/normalizeKeywords";

import type { SingleSuggestion, SuggestionProvider } from "@/components/suggestions/types";

function mapExpressionToSuggestion(
  expression: ExpressionsJsonItem,
): SingleSuggestion<"expression"> {
  return {
    type: "single",
    item: {
      type: "expression",
      symbol: expression.symbol ?? "",
      code: expression.code,
      displayName: expression.name,
      keywords: normalizeSuggestionKeywords(expression),
      nodesJson: expression.nodesJson,
      category: expression.category ?? "",
      labelPlaceholderVisible: expression.labelPlaceholderVisible,
    },
    action: {
      type: "insert-expression",
      nodesJson: expression.nodesJson,
      targetNode: expression.targetNode,
      fallbackTargetNode: expression.fallbackTargetNode,
    },
    nestedKey: expression.nestedKey,
    priority: expression.priority ?? 1,
  };
}

export const expressionSuggestions = expressionsJson.map(mapExpressionToSuggestion);

export const expressionSuggestionsProvider: SuggestionProvider = {
  type: "expression",
  search: (str, doc, lang) => {
    if (doc.selection.hasTextSelection || doc.libraries.serves("expressions.json")) {
      return [];
    }

    const filtered = filterSuggestions(str, expressionSuggestions, { lang });
    return [
      filtered.map((suggestion) =>
        injectNodePropsToSuggestion(doc, suggestion, {
          extend: (injectedNodesJson) => ({
            action: {
              ...suggestion.action!,
              nodesJson: injectedNodesJson,
            },
          }),
        }),
      ),
    ];
  },
};
